<template>
  <v-card class="dialog">
    <v-container class="ma-0 pa-0">
      <v-form ref="form" v-model="valid">
        <v-card-title >
          <span class="headline" v-if="page === 1"> Upload de Anexos</span>
          <span class="headline" v-if="page === 2"> Upload de Proposta</span>
          <span class="headline" v-if="page === 3"> Upload de Anexos</span>
        </v-card-title>

        <v-card-text class="px-4">
          <v-layout column row v-if="page === 1">
            <div class="borda">
              <span class="texto">Selecione o tipo de documento:</span>
            <v-layout row wrap>
              <v-layout>
                <v-btn class="button-permanecer3" disabled flat>
                APÓLICE
              </v-btn>
              </v-layout>
            <v-layout row wrap>
              <v-btn class="button-permanecer2" flat @click="page = page + 1">
                PROPOSTA
              </v-btn>
              </v-layout>
              <v-layout>            
                <v-btn 
                  :disabled="disableArquivoDeclacaraoSeguro" 
                  :class="classeDesabilitaBotao" 
                  flat 
                  @click="pickFile('inputArquivoDeclaracaoSeguro')"
                >
                  DECLARAÇÃO DE SEGURO                    
                  <input 
                    style="display: none"
                    id="inputArquivoDeclaracaoSeguro" 
                    ref="inputArquivoDeclaracaoSeguro" 
                    type="file"
                    v-on:change="addArquivoDeclaracaoSeguro()" />
                </v-btn>
              </v-layout>

              <v-layout>
                <v-btn class="button-permanecer2"
                  :disabled="disableArquivoOutros" 
                  :class="classeDesabilitaBotao" 
                  flat 
                  @click="pickFile('inputArquivoOutros')"
                >
                  OUTROS ARQUIVOS
                  <input 
                    style="display: none"
                    id="inputArquivoOutros" 
                    ref="inputArquivoOutros" 
                    type="file"
                    v-on:change="addArquivoOutros()" />
                </v-btn>
              </v-layout>
              <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
                {{ snackText }}
              </v-snackbar>
            </v-layout>
          </div>
          </v-layout>

          <v-layout column row v-else-if="page === 2">
            <v-layout>
              <span class="texto">Selecione o tipo de proposta:</span>
            </v-layout>
            <div class="borda">

              <v-layout row wrap>

                <v-flex xs12 text-xs-center v-if="permissaoAnalisaSolicitacao">
                  <v-layout row wrap align-center align-content-center v-if="!arquivoAcidente">
                    <span 
                      v-if="arquivoRoubo != null && arquivoAcidente == null" 
                      class="red--text"
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Adicione uma proposta de acidente*
                    </span>
                    <v-btn 
                      :disabled="disableArquivoAcidenteMaisArquivoRoubo" 
                      :class="classeDesabilitaBotao" 
                      flat 
                      @click="pickFile('inputArquivoAcidente')"
                    >
                      ACIDENTE
                      <input 
                        style="display: none"
                        id="inputArquivoAcidente" 
                        ref="inputArquivoAcidente" 
                        type="file"
                        v-on:change="addArquivoAcidente()" />
                    </v-btn>
                  </v-layout>
                  <v-flex v-else>
                    <v-layout row wrap align-center align-content-center class="arquivoAnexado">
                      <v-flex xs9 lg10 text-xs-left>
                        <i>{{ arquivoAcidente.nomeArquivo }}</i>
                      </v-flex>
                      <v-flex xs2 text-xs-right>
                        <v-btn flat icon @click="removeArquivo('arquivoAcidente')">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>

                <v-flex xs12 text-xs-center v-if="permissaoAnalisaSolicitacao">
                  <v-flex v-if="!arquivoRoubo">
                    <v-layout row wrap>
                      <v-flex xs12 lg8>
                        <v-btn 
                          :disabled="disableArquivoAcidenteMaisArquivoRoubo"
                          :class="classeDesabilitaBotao"
                          flat
                          @click="pickFile('inputArquivoRoubo')"
                        >
                          ROUBO
                          <input 
                            style="display: none"
                            id="inputArquivoRoubo" 
                            ref="inputArquivoRoubo" 
                            type="file"
                            v-on:change="addArquivoRoubo()"/>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-else>
                    <v-layout row wrap align-center align-content-center class="arquivoAnexado">
                      <v-flex xs9 lg10 text-xs-left >
                        <i>{{ arquivoRoubo.nomeArquivo }}</i>
                      </v-flex>
                      <v-flex xs2 text-xs-right>
                        <v-btn flat icon @click="removeArquivo('arquivoRoubo')">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>

                <v-flex xs12 text-xs-center v-if="permissaoAnalisaSolicitacao">
                  <v-layout row wrap v-if="!arquivoAcidenteRoubo">
                    <v-btn 
                      :disabled="disableAcidenteRoubo" 
                      :class="classeDesabilitaBotaoAcidenteRoubo"
                      flat
                      @click="pickFile('inputArquivoAcidenteRoubo')"
                    >
                      ACIDENTE E ROUBO
                      <input 
                        style="display: none"
                        id="inputArquivoAcidenteRoubo" 
                        ref="inputArquivoAcidenteRoubo" 
                        type="file"
                        v-on:change="addArquivoAcidenteRoubo()"/>
                    </v-btn>
                  </v-layout>
                  <v-flex v-else>
                    <v-layout row wrap align-center align-content-center class="arquivoAnexado">
                      <v-flex xs9 lg10 text-xs-left >
                        <i>{{ arquivoAcidenteRoubo.nomeArquivo }}</i>
                      </v-flex>
                      <v-flex xs2 text-xs-right>
                        <v-btn flat icon @click="removeArquivo('arquivoAcidenteRoubo')">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
              </v-layout>
            </div>
            <v-flex xs12 text-xs-center>
              <v-text-field label="Descrição"
                id="txtDescricaoArquivo"
                v-model="descricaoEnvio"
                :rules="formRulesComputed.arquivo.proposta.descricao(descricaoEnvio)">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout column row v-else-if="page === 3">
            <div class="borda">
              <span class="texto">Arquivos a serem enviados:</span>
            <v-layout row wrap>
              <v-layout>
              <v-btn class="button-permanecer2" flat>
                ANEXAR MAIS DOCUMENTOS
              </v-btn>
              </v-layout>
            </v-layout>
          </div>
          </v-layout>
          <v-layout row justify-center>
          <v-dialog persistent v-model="dialogProgress" max-width="800px">
            <v-card class="dialog">
              <v-card-title class="primary">
                <span class="headline">ENVIANDO SOLICITAÇÃO</span>
              </v-card-title>
              <v-card-text >
                <div grid-list-md>
                  <v-layout wrap>
                    <v-flex align-center d-flex xs12>
                      <span>
                          Por favor, aguarde o processamento. Isso pode levar alguns segundos.
                      </span>
                    </v-flex>
                    <v-flex align-center d-flex xs12>
                      <v-progress-linear
                        heigth="2px"
                        indeterminate
                        color="primary"
                      ></v-progress-linear>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>

            </v-card>
          </v-dialog>
        </v-layout>
        </v-card-text>
        <v-card-actions class="px-4 pb-5">
          <v-layout row>
            <v-flex  v-if="page === 1" md4 xs6>
              <v-btn  @click="fechar" class="btn-width-maior" flat color="primary">
                FECHAR
              </v-btn>
            </v-flex>
            <v-flex md6 class="btn-mobile-special" xs12 v-else>
              <v-btn
                flat
               
                @click="page = page - 1"
                color="primary"
              >
                VOLTAR
              </v-btn>
            </v-flex>
            
            <v-flex class="btn-mobile-special" md6 xs12 v-if="page === 2">
              <!-- <v-btn class="button-permanecer4"  flat @click="page = page + 1" >
                AVANÇAR
              </v-btn> -->
              <v-btn 
                :disabled="validadeArquivosAdicionados" 
                :class="classeDesabilitaBotaoAnexar" 
                flat 
                @click="anexar()"
              >
                ANEXAR
              </v-btn>
            </v-flex>
            <v-flex class="btn-mobile-special" md6 xs12 v-if="page === 3">
              <v-btn class="button-permanecer4"  flat >
                ENVIAR
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";
import formRules from '@/helpers/form-rules';
import tipoProposta from '@/helpers/tipo-proposta';
import permissoes from '@/helpers/permissoes';
import usuarioHelper from '@/helpers/usuario-logado';
import arquivoFunctions from '@/components/pages/solicitacao-consulta/ArquivoFunctions'

export default {
  name: "ModalAnexarArquivoTratativa",

  data() {
    return {
      menu: false,
      snack: false,
      valid: false,
      snackColor: "",
      dadosCadastraisCliente: {},
      snackText: "",
      erroAjuda: null,
      dialogProgress: false,
      dialogError: false,
      errorMessage: "",
      errorDetails: null,
      arquivoAnexado: [],
      arquivoAcidente: null,
      arquivoAcidenteRoubo: null,
      arquivoDeclaracaoSeguro: null,
      arquivoRoubo: null,
      arquivoOutros: null,
      descricaoEnvio: '',
      arquivoModel: {
        descricao: '',
        nomeArquivo: null,
        tipoArquivo: {}, 
        idQuestionario: null,
        tokenUsuario: null,
        mimeType: null,
        downloadLink: null,
        visualizacaoAnalista: false,
        visualizacaoCliente: false,
        tipoProposta: {},
        arquivo: null
      },
      modalAceite: {
        opened: false,
        proposta: null,
        processando: false,
        chkRecusarPropostaRouboValue: false,
        datePicker: {
          opened: false,
          dataVigenciaDesejada: null,
          dataVigenciaDesejadaFormatted: null
        }
      },
      page: 1,
      regras: {
        notNull: [
          v =>
            (v !== null && v !== undefined && v !== "") ||
            "Você não pode deixar este campo em branco"
        ]
      }
    };
  },

  props: {
    dialog: Boolean,
    model: {},
  },
  computed: {
    permissaoAnalisaSolicitacao: function() {
      return permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.COTAR_SEGURO)
    },
    tipoPropostaComputed: function () {
      return tipoProposta;
    },
    elementoPai: function() {
      return this.$parent;
    },
    disableArquivoAcidenteMaisArquivoRoubo: function() {
      return this.arquivoAcidenteRoubo != null;
    },
    disableArquivoDeclacaraoSeguro: function() {
      return this.arquivoDeclaracaoSeguro != null;
    },
    disableArquivoOutros: function() {
      return this.arquivoOutros != null;
    },
    disableAcidenteRoubo: function() {
      return this.arquivoAcidente != null || this.arquivoRoubo != null;
    },
    classeDesabilitaBotao: function() {
      return this.disableArquivoAcidenteMaisArquivoRoubo
        ? 'button-permanecer3'
        : 'button-permanecer2'
    },
    classeDesabilitaBotaoAcidenteRoubo: function() {
      return this.disableAcidenteRoubo
        ? 'button-permanecer3'
        : 'button-permanecer2'
    },
    classeDesabilitaBotaoAnexar: function() {
      return this.validadeArquivosAdicionados
        ? 'button-permanecer5'
        : 'button-permanecer4'
    },
    validadeArquivosAdicionados: function() {
      if ((this.arquivoRoubo != null && this.arquivoAcidente == null)
        || (this.arquivoRoubo == null && this.arquivoAcidente == null && this.arquivoAcidenteRoubo == null)
        || (this.descricaoEnvio === '')) {
        return true;
      }
      return false;
    },
    formRulesComputed: function() {
      return formRules;
    },
  },

  methods: {
    pickFile: function(ref) {
      eval('this.$refs.' + ref + '.click()');
    },
    addArquivoAcidente: function() {
      const fileInput = this.$refs.inputArquivoAcidente.files[0];
      
      this.arquivoModel.nomeArquivo = fileInput.name;
      if(this.permissaoAnalisaSolicitacao) {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA;
      } else {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA_ASSINADA;
      }      
      this.arquivoModel.idQuestionario = this.model.id;
      this.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      this.arquivoModel.mimeType = fileInput.type;
      this.arquivoModel.tipoProposta = arquivoFunctions.tipoProposta.ACIDENTE;

      this.arquivoAcidente = JSON.parse(JSON.stringify(this.arquivoModel));
      this.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          this.arquivoAcidente.arquivo = response;
        } else {
          this.arquivoAcidente = null;
        }
      });

      this.resetArquivoModel();
    },
    addArquivoRoubo: function() {
      const fileInput = this.$refs.inputArquivoRoubo.files[0];
      
      this.arquivoModel.nomeArquivo = fileInput.name;
      if(this.permissaoAnalisaSolicitacao) {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA;
      } else {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA_ASSINADA;
      } 
      this.arquivoModel.idQuestionario = this.model.id;
      this.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      this.arquivoModel.mimeType = fileInput.type;
      this.arquivoModel.tipoProposta = arquivoFunctions.tipoProposta.ROUBO;

      this.arquivoRoubo = JSON.parse(JSON.stringify(this.arquivoModel));
      this.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          this.arquivoRoubo.arquivo = response;
        } else {
          this.arquivoRoubo = null;
        }
      });

      this.resetArquivoModel();
    },
    addArquivoAcidenteRoubo: function() {
      const fileInput = this.$refs.inputArquivoAcidenteRoubo.files[0];
      
      this.arquivoModel.nomeArquivo = fileInput.name;
      if(this.permissaoAnalisaSolicitacao) {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA;
      } else {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA_ASSINADA;
      } 
      this.arquivoModel.idQuestionario = this.model.id;
      this.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      this.arquivoModel.mimeType = fileInput.type;
      this.arquivoModel.tipoProposta = arquivoFunctions.tipoProposta.ACIDENTE_ROUBO;

      this.arquivoAcidenteRoubo = JSON.parse(JSON.stringify(this.arquivoModel));
      this.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          this.arquivoAcidenteRoubo.arquivo = response;
        } else {
          this.arquivoAcidenteRoubo = null;
        }
      });

      this.resetArquivoModel();
    },
    addArquivoDeclaracaoSeguro: function() {
      const fileInput = this.$refs.inputArquivoDeclaracaoSeguro.files[0];
      
      this.arquivoModel.nomeArquivo = fileInput.name;
      if(this.permissaoAnalisaSolicitacao) {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.DECLARACAO_SEGURO;
      } else {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.DECLARACAO_SEGURO;
      } 
      this.arquivoModel.idQuestionario = this.model.id;
      this.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      this.arquivoModel.mimeType = fileInput.type;
      this.arquivoModel.tipoProposta = arquivoFunctions.tipoProposta.DECLARACAO_SEGURO;
      this.arquivoModel.descricao = "DECLARACAO_SEGURO";

      this.arquivoDeclaracaoSeguro = JSON.parse(JSON.stringify(this.arquivoModel));
      this.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          this.arquivoDeclaracaoSeguro.arquivo = response;
        } else {
          this.arquivoDeclaracaoSeguro = null;
        }
      });
      this.resetArquivoModel();
      
      if (this.arquivoDeclaracaoSeguro != null) {
        this.arquivoAnexado.push(this.arquivoDeclaracaoSeguro)
      }

      this.$emit('arquivoAnexado', this.arquivoAnexado)
      this.$emit("fechar");
    },
    addArquivoOutros: function() {
      const fileInput = this.$refs.inputArquivoOutros.files[0];
      
      this.arquivoModel.nomeArquivo = fileInput.name;
      if(this.permissaoAnalisaSolicitacao) {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.OUTROS;
      } else {
        this.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.OUTROS;
      } 
      this.arquivoModel.idQuestionario = this.model.id;
      this.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      this.arquivoModel.mimeType = fileInput.type;
      this.arquivoModel.tipoProposta = arquivoFunctions.tipoProposta.OUTROS;
      this.arquivoModel.descricao = arquivoFunctions.tipoArquivo.OUTROS.descricao;

      this.arquivoOutros = JSON.parse(JSON.stringify(this.arquivoModel));
      this.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          this.arquivoOutros.arquivo = response;
        } else {
          this.arquivoOutros = null;
        }
      });
      this.resetArquivoModel();

      this.anexar();
    },
    removeArquivo: function(tipoArquivo) {
      eval('this.' + tipoArquivo + ' = null;');
    },
    arquivoParaByteArray: async function(arquivo) {
      var reader = new FileReader();
      return new Promise((resolve, reject) => {
        var fileByteArray = [];
        reader.readAsArrayBuffer(arquivo);
        reader.onerror = function () {
          reject(null);
        }
        reader.onloadend =  function (evt) {
          if (evt.target.readyState == FileReader.DONE) {
            var arrayBuffer = evt.target.result,
              array = new Uint8Array(arrayBuffer);
            for (var i = 0; i < array.length; i++) {
              fileByteArray.push(array[i]);
            }
            resolve(fileByteArray);
          }
        }
      });
    },
    anexar() {
      if (this.arquivoAcidente != null) {
        this.arquivoAcidente.descricao = this.descricaoEnvio
        this.arquivoAnexado.push(this.arquivoAcidente)
      }
      if (this.arquivoRoubo != null) {
        this.arquivoRoubo.descricao = this.descricaoEnvio
        this.arquivoAnexado.push(this.arquivoRoubo)
      }
      if (this.arquivoAcidenteRoubo != null) {
        this.arquivoAcidenteRoubo.descricao = this.descricaoEnvio
        this.arquivoAnexado.push(this.arquivoAcidenteRoubo)
      }
      if (this.arquivoOutros != null) {
        this.arquivoAnexado.push(this.arquivoOutros)
      }

      this.$emit('arquivoAnexado', this.arquivoAnexado)
      this.$emit("fechar");
    },
    fechar() {
      this.$emit("fechar");
    },
    resetArquivoModel: function() {
      const self = this;
      self.arquivoModel = {
        descricao: '',
        nomeArquivo: null,
        tipoArquivo: {}, 
        idQuestionario: null,
        tokenUsuario: null,
        mimeType: null,
        downloadLink: null,
        visualizacaoAnalista: false,
        visualizacaoCliente: false
      };
    },
  }
};
</script>

<style scoped>
.color {
  background-color: #eaeaea;
}

.headline {
  color: #00456e;
  font-size: 25px !important;
}

.textModal {
  color: black;
  font-size: 16px;
  color: #646464; 
  text-align: left;
}

.borda{
  padding-left: 10px;
  border:dashed 1px;
  margin: 50px;
  margin-top: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.textModal2 {
  color: black;
  font-size: 110%;
  text-align: left;
  font-weight: bolder;
}

.button-permanecer {
  background: #00456e;
  color: #fff !important;
}

.button-permanecer2 {
  width: 200px;
  background: #40bccc;
  color: #fff !important;
  margin-left: 65px !important;
  margin: 15px;
}

.button-permanecer3 {
  width: 200px;
  background: #d3cbcb;
  color: black;
  margin-left: 65px !important;
  margin: 15px;
}

.button-permanecer4 {
  width: 150px;
  background: #00456e;
  color: #fff !important;
  margin-left: 65px;
}

.button-permanecer5 {
  width: 150px;
  background: #d3cbcb;
  color: black;
  margin-left: 65px;
}

.special-flex {
  display: flex;
  justify-content: flex-end;
}

.btn-width-maior {
  width: 90%;
}

.texto{
  margin-left: 50px;

}

.arquivoAnexado {
  border: 2px solid #E5E5E5; 
  border-radius: 3px; 
  background-color: #E5E5E5; 
  max-height: 45px;
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/ModalAnexarArquivoTratativa.vue